import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { LayoutFrame, registerHomeTile } from '@room/shared-ui';
import './DocsPage.css';

registerHomeTile({
  id: 'home-docs',
  label: 'Docs',
  icon: '📖',
  route: '/docs',
  section: 'main',
  order: 40,
});

export function DocsPage() {
  const [content, setContent] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadDocs = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch('/docs/README.md');
        if (!response.ok) {
          throw new Error('Unable to load documentation');
        }
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unable to load documentation');
      } finally {
        setIsLoading(false);
      }
    };

    void loadDocs();
  }, []);

  return (
    <LayoutFrame narrow>
      <div className="section-header">
        <h1 className="page-title">Docs</h1>
        <p className="page-subtitle">Quick links and the latest documentation snapshot.</p>
      </div>

      <div className="content-card">
        <div className="section-title">Quick links</div>
        <ul className="doc-links">
          <li>
            <a
              href="/docs/README.md"
              target="_blank"
              rel="noreferrer"
              className="doc-link"
            >
              📖 Product documentation
            </a>
          </li>
          <li>
            <a
              href="/docs/DEPLOYMENT_GUIDE.md"
              target="_blank"
              rel="noreferrer"
              className="doc-link"
            >
              🚀 Deployment guide
            </a>
          </li>
          <li>
            <a
              href="/docs/DEBUG_GUIDE.md"
              target="_blank"
              rel="noreferrer"
              className="doc-link"
            >
              🔍 Debugging guide
            </a>
          </li>
        </ul>
      </div>

      <div className="content-card content-card-subtle">
        <div className="section-title">Documentation preview</div>
        {isLoading && <p className="loading-text">Loading documentation…</p>}
        {error && <div className="alert alert-error">{error}</div>}
        {!isLoading && !error && (
          <div className="doc-content content-wrap" aria-label="Documentation preview">
            {content ? <ReactMarkdown>{content}</ReactMarkdown> : 'Documentation content not available.'}
          </div>
        )}
      </div>
    </LayoutFrame>
  );
}
